module.exports = __webpack_public_path__ + "media/images/thumbs/muscles/apelv4-29f8fea8c340d043e33bd821f072659e.jpg";